function isChineseChar(str) {
  const reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/

  return reg.test(str)
}

export default function getChineseLength(value) {
  return value
    .split('')
    .reduce(
      (acc, cur) => (isChineseChar(cur) ? acc + 2 : acc + 1),
      0,
    )
}
